import Reveal from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import GoldSeam from "@/components/GoldSeam";
import { waLink, WHATSAPP_DISPLAY } from "@/lib/site";

export default function Contact() {
  return (
    <main className="pt-16" data-testid="contact-page">
      <section className="relative py-24 md:py-36 overflow-hidden">
        <div
          className="absolute -top-32 right-0 w-[480px] h-[480px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(169,129,47,0.105), transparent 62%)" }}
          aria-hidden="true"
        />
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 lg:gap-24">
          <div>
            <Reveal>
              <p className="eyebrow mb-6">Contact</p>
              <h1
                className="font-display text-ink font-medium leading-[1.08]"
                style={{ fontSize: "clamp(2.6rem, 5.5vw, 4.6rem)" }}
                data-testid="contact-page-heading"
              >
                Start a T.A.L.K.
              </h1>
              <p className="mt-8 text-inkdim leading-relaxed max-w-md text-[15px] md:text-base" data-testid="contact-page-microcopy">
                This isn't advice about how to live. It's a conversation that helps you
                see the pattern you've been too close to notice.
              </p>
              <GoldSeam variant="horizontal" className="mt-10 w-56 h-10 opacity-60" delay={0.2} />
              <div className="mt-10 space-y-4 text-sm">
                <p className="text-inkdim">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-gold block mb-1.5">Write directly</span>
                  <a href="mailto:brarrajdeep369@gmail.com" className="gold-underline-link text-ink" data-testid="contact-email-link">
                    brarrajdeep369@gmail.com
                  </a>
                </p>
                <p className="text-inkdim">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-gold block mb-1.5">WhatsApp</span>
                  <a href={waLink()} target="_blank" rel="noopener noreferrer" className="gold-underline-link text-ink" data-testid="contact-whatsapp-link">
                    {WHATSAPP_DISPLAY}
                  </a>
                </p>
                <p className="text-inkdim">
                  <span className="text-[10px] uppercase tracking-[0.3em] text-gold block mb-1.5">Response time</span>
                  Within two working days — considered, not templated.
                </p>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.12} className="lg:pt-14">
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </main>
  );
}
